module.exports = [
    'Accessbank Tanzania',
'Letshego Bank Tanzania',
'Akiba Commercial Bank',
'Amana Bank',
'Azania Bank',
'Bancabc',
'Bank Of Africa Tanzania',
'Bank Of Baroda Tanzania Limited',
'Bank Of India',
'Barclays Bank Of Tanzania',
'Citibank',
'Commercial Bank Of Africa ',
'Crdb Bank',
'Dcb Commercial Bank',
'Diamond Trust Bank Tanzania',
'Ecobank',
'Equity Bank',
'Exim Bank',
'Finca Microfinance Bank',
'First National Bank Of Tanzania',
'Fbme Bank',
'Guaranty Trust Bank Limited',
'Habib African Bank',
'I&M Bank ',
'International Commercial Bank',
'Kenya Commercial Bank',
'Mkombozi Commercial Bank',
'National Bank Of Commerce ',
'National Microfinance Bank',
'Nic Bank Tanzania',
'Peoples Bank Of Zanzibar',
'Stanbic Bank Tanzania Limited',
'Standard Chartered Bank',
'United Bank For Africa',
'Ubl Bank Tanzania Limited',
'Mwalimu Commercial Bank',
'Tpb Bank Plc',
'Tib Corporate Bank',
'First Housing Company Tanzania Limited',
'China Dasheng Bank Limited',
'Tanzania Agricultural Development Bank',
'Tanzania Mortgage Refinance Company',
'Tib Development Bank',
'Kilimanjaro Cooperative Bank',
'Maendeleo Bank Plc',
'Mufindi Community Bank Plc',
'Mwanga Rural Community Bank Limited',
'Tandahimba Community Bank Limited',
'Tanzania Womenâ Bank',
'Uchumi Commercial Bank Limited.',
'Efc Tanzania Microfinance Bank',
'Finca Microfinance Bank'
    
];